import { render, staticRenderFns } from "./billperiod.vue?vue&type=template&id=23d8154a&"
import script from "./billperiod.vue?vue&type=script&lang=ts&"
export * from "./billperiod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "billperiod.vue"
export default component.exports